import { SurveyForm } from 'ui/components/agent/patterns/SurveyForm/SurveyForm';

/**
 * アンケートフォーム
 */
export const AgentSurveyForm: React.FC = () => {
    return <SurveyForm />;
};
